import { useMemo } from 'react';

import range from '../../helpers/array/range';

const useRangeAsOptions = (
    min: number,
    max: number,
    renderLabel?: (x: number) => string
) => {
    const valueToLabel = renderLabel
        ? (x: number) => renderLabel(x)
        : (x: number) => x.toString();

    return useMemo(
        () =>
            range(min, max).map((x) => ({
                value: x.toString(),
                label: valueToLabel(x),
            })),
        [min, max, renderLabel]
    );
};

export default useRangeAsOptions;
